import { useEffect, useState } from "react";
import { unitType } from "../../../util/unitType";
import { toast } from "react-toastify";
import { reformatData } from "../../../util/helperFunctions";
import { getModelPlotData } from "../../model/util/modelUtils";
import { fetchExpressions } from "../../../api/sensorApi";
import { fetchData } from "../../../api/cancuiApi";


const extractRowData = (tableData, result, key, metricKey, dataColumn) => {
    if(tableData.length === 0) {
        for(let i in result[key][metricKey]["data"]) {
            let item = result[key][metricKey]["data"][i].toFixed(3);
            let timestamp = result[key][metricKey]["dates"][i];
            let row = { timestamp: timestamp, [dataColumn]: item };
            tableData.push(row);
        };
    }else {
        for(let i in result[key][metricKey]["data"]) {
            let item = result[key][metricKey]["data"][i].toFixed(3);
            let timestamp = result[key][metricKey]["dates"][i];
            let row = tableData.find(r => r.timestamp === timestamp);
            if(row) {
                row[dataColumn] = item;
            }
        }
    }
}

const formatToTableData = (data) => {
    let tableData = [];
    for(let d of data) {
        console.log(d)
        let result = d["result"];
        let key = Object.keys(result)[0];
        let metricKey = Object.keys(result[key])[0];
        if(metricKey === "CC_Temperature") {
            extractRowData(tableData, result, key, metricKey, "calculatedTemperature");
        }
        if(metricKey === "RawValue") {
            extractRowData(tableData, result, key, metricKey, key);
        }
    }
    return tableData;
}


const getTagData = async (tag, start, end, interval) => {
    const tag_spec = {
            tag: tag,
            start: start.format("YYYY-MM-DD"),
            end: end.format("YYYY-MM-DD"),
            interval: interval,
        }

    try {
        var temp_res = await fetchExpressions("PointMeasurementExpression", tag_spec);
        return temp_res;
    } catch (error) {
        console.error("Error fetching tag data:", error);
        toast.error("Error fetching tag data. Please try again later.");
        return [];
    }
}

const getTemperatureData = async (id, tags, start, end, interval, units) => {
    const spec = {
        subject_filter: `sensor.id = '${id}'`,
        start: start.format("YYYY-MM-DD"),
        end: end.format("YYYY-MM-DD"),
        units: [unitType(units, 'temperature')],
        expressions: ["CC_Temperature"],
        interval: interval,
    }

    try {
        const res = await fetchExpressions("SensorExpression", spec);
        //wait for all tags raw value to be fetched
        console.log("Fetching tag data for tags:", tags);
        const tagData = await Promise.all(tags.map(tag => getTagData(tag, start, end, interval)));
        console.log("Fetched temperature data:", res);
        console.log("Fetched tag data:", tagData);
        const allData = [res, ...tagData];
        const reformattedData = reformatData(allData);
        console.log("Reformatted temperature data:", reformattedData);
        const tableData = formatToTableData(reformattedData);
        console.log("Formatted table data:", tableData);
        // console.log("Reformatted temperature data:", reformatData([res]));
        return tableData;
    } catch (error) {
        console.error("Error fetching temperature data:", error);
        toast.error("Error fetching temperature data. Please try again later.");
        return [];
    }
}


function useGetTemperatureFormulaTagData(id, start, end, interval, units, tags) {
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {

        async function fetchData() {
            console.log("Fetching temperature formula tag data with params:", { id, start: start.format("YYYY-MM-DD"), end: end.format("YYYY-MM-DD"), interval, units, tags });
            if (id && tags && tags.length > 0 && start && end && interval) {
                setIsLoading(true);
                try {
                    // Fetch temperature data
                    const tempData = await getTemperatureData(id, tags, start, end, interval, units);
                    setData(tempData);
                    // if (tempData.length > 0) {
                    //     // Fetch temperature flags
                    //     const { isClusterData } = await getTempFlags(id, start, end, units);
                    //     console.log(tempData)
                    //     const formattedData = getModelPlotData(tempData[0], features, units, id, isClusterData);
                    //     console.log("Formatted Temperature Data:", formattedData);
                    //     // // Fetch min/max temperature IDs
                    //     // const tempId = await fetchMinMaxTempIds(site, start, end, units);

                    //     // Fetch min/max temperature data
                    //     const minMaxTempData = await fetchMinMaxTempData(id, start, end, units);
                    //     if (minMaxTempData.length === 0) {
                    //         toast.error("No min/max temperature data found for the specified ID.");
                    //         return;
                    //     }
                    //     const minMaxFormattedData = getModelPlotData(minMaxTempData[0], minMaxTempFeatures, units, id);
                    //     console.log("Formatted Min/Max Temperature Data:", minMaxFormattedData);
                    //     setData([...formattedData, ...minMaxFormattedData]);
                    // } else {
                    //     toast.error("No temperature data found for the specified ID.");
                    // }
                }
                catch (error) {
                    console.error("Error fetching temperature data:", error);
                    toast.error("Error fetching temperature data. Please try again later.");
                } finally {
                    setIsLoading(false);
                }

            }
        }
        fetchData();

    }, [id, start, end, interval, units, tags]);

    return { data, isLoading };
}

export default useGetTemperatureFormulaTagData;